import type { StatusNotificationDomain } from '@/protocol/OcppAdapter';

export function buildStatusNotificationRequest(
  req: StatusNotificationDomain,
): Record<string, unknown> {
  const wire: Record<string, unknown> = {
    connectorId: req.connectorId,
    status: req.status,
    errorCode: req.errorCode ?? 'NoError',
  };
  if (req.info !== undefined) wire['info'] = req.info;
  if (req.timestamp !== undefined) wire['timestamp'] = req.timestamp;
  if (req.vendorId !== undefined) wire['vendorId'] = req.vendorId;
  if (req.vendorErrorCode !== undefined) wire['vendorErrorCode'] = req.vendorErrorCode;
  return wire;
}
